<template>
    <div id="transfer-history-page" class="gradbg">
        <div class="header-panel">
            <h1>First Home Saver Transfer History</h1>
        </div>
        <div class="table-panel">
            <div class="balance">
                <label>Current Balance</label>
                <output>{{ activeSavingsAccount.balances[0].amount|currency }}</output>
            </div>
            <table v-if="transferLog">
                <tr v-for="(tx, index) in transferLog" :key="index">
                    <td>{{ tx.transactionDate|fmtdate("MM/dd/yyyy") }}</td>
                    <td>{{ tx.description }}</td>
                    <td>{{ tx.transactionAmount|currency }}</td>
                    <td>{{ getRunningBalance(index)|currency }}</td>
                </tr>
            </table>
        </div>
    </div>
</template>
<script>
import {mapState, mapGetters} from 'vuex'

export default {
    name: 'transfer-history',
    data() {
        return {
            // transfers: [],
        }
    },
    computed: {
        ...mapState(['bankInfo', 'transferLog']),
        ...mapGetters(['activeSavingsAccount']),
    },
    methods: {
        async getHistory() {
            // let r = await fetch('https://fisential.com/fake-data/transfers.json')
            // this.transfers = await r.json()
        },

        getRunningBalance(index) {
            let sum = 0;
            for (let i = index - 1; i >= 0; i--) {
                let tx = this.transferLog[i];
                sum -= tx.transactionAmount
            }

            return sum + Number(this.activeSavingsAccount.balances[0].amount)
        },

    },
    created() {
        // this.getHistory()
    },
}
</script>
<style lang="scss">
#transfer-history-page {
    flex: 1 1 100%;

    display: flex;
    flex-flow: column nowrap;
    height: 100%;

    .header-panel h1 {
        width: 98vmin;
        max-width: 320px;
        font-size: 18px;
    }

    .table-panel {
        flex: 1 1 100%;
        background: white;

        .balance {
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;

            padding: 20px;

            label {
                font-size: 14px;
                font-weight: bold;
            }
            output {
                font-size: 14px;
                font-weight: bold;
            }
        }

        table {
            width: 100%;
            td {
                font-size: 11px;
                font-weight: bold;
                padding: 12px 6px;
            }

            tr:nth-child(odd) td {
                background: #E6F3FC;
            }
        }
    }
}
</style>
